import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../assets/vip.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4024b911"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "易答", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"20px"}
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "userName" }
const _hoisted_6 = {
  key: 1,
  style: {"margin-left":"100px"}
}

import { routes } from "@/router";
import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useLoginUserStore } from "@/store/userStore";
import checkAccess from "@/access/checkAccess";
import { userLogoutUsingPost } from "@/api/userController";
import VipWindow from "@/components/VipWindow.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const router = useRouter();
const userStore = useLoginUserStore();

/**
 * 过滤菜单
 */
const filterRouters = computed(() => {
  return routes.filter((item) => {
    // 根据权限过滤菜单
    if (!checkAccess(userStore.loginUser, item.meta?.access as string)) {
      return false;
    }
    // 根据隐藏过滤菜单
    if (item.meta?.showInMenu == true) {
      return true;
    }
    return false;
  });
});
/**
 * 点击菜单跳转
 */
const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
};

const click = (url: string) => {
  router.push({ path: url });
};
/**
 * 路由跳转后更新选中菜单项
 */
const selectKeys = ref([""]);
router.afterEach((to) => {
  selectKeys.value = [to.path];
});

/**
 * 登出
 */
function loginOut() {
  userLogoutUsingPost({ id: userStore.loginUser.id }).then(() => {
    userStore.loginUser = {};
  });
  router.go(0);
}

/**
 * 点击下拉菜单
 */
function handleSelect(key: string) {
  if (key === "logout") {
    loginOut();
  }
}

const vipVisible = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_icon_down = _resolveComponent("icon-down")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    align: "center",
    wrap: false,
    justify: "center",
    id: "globalHeader"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        flex: "100px",
        style: {"margin-left":"50px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (click('/')))
          }, [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            "selected-keys": selectKeys.value,
            onMenuItemClick: doMenuClick
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterRouters.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "90px" }, {
        default: _withCtx(() => [
          (_unref(userStore).loginUser.id)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (vipVisible.value = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createVNode(_component_a_typography_text, null, {
                        default: _withCtx(() => [
                          _createTextVNode("会员")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "200px" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              (_unref(userStore).loginUser.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_avatar, {
                          "image-url": _unref(userStore).loginUser.userAvatar,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (click('/my/user')))
                        }, null, 8, ["image-url"]),
                        _createVNode(_component_a_dropdown, {
                          onSelect: handleSelect,
                          "popup-max-height": true
                        }, {
                          content: _withCtx(() => [
                            _createVNode(_component_a_doption, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_link, {
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (click('/my/user')))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 我的信息")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_doption, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_link, {
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (click('/my/favour/interviewQuestion')))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 收藏题目 ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_doption, {
                              key: "logout",
                              onClick: loginOut
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 退出登录")
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(userStore).loginUser.userName ?? "无名"), 1),
                                _createVNode(_component_icon_down)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (click('/user/login')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("登录 ")
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_modal, {
        visible: vipVisible.value,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((vipVisible).value = $event)),
        "hide-cancel": ""
      }, {
        title: _withCtx(() => [
          _createTextVNode(" 会员中心")
        ]),
        default: _withCtx(() => [
          _createVNode(VipWindow, { style: {"margin-left":"90px"} })
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}
}

})